import React, { ComponentType, PureComponent } from "react";

import { HttpError } from "@/browser";
import { errorEntryType, getCode } from "@/core/api";

import { Error4XX } from "./Error4XX";
import { Error5XX } from "./Error5XX";
import { IWithHttpErrorProps } from "./types";

const ERROR_CODES_4XX = ["NOT_FOUND", "ARGUMENT_TYPE_MISMATCH", "ACCESS_DENIED"];

export function withHttpError<P extends IWithHttpErrorProps>(Component: ComponentType<P>) {
  return class WithError extends PureComponent<P> {
    renderErrorPage() {
      const error = this.props.error as HttpError;
      const errorCode = getCode(errorEntryType(error.payload));
      const errorStatus = error.status;

      if (ERROR_CODES_4XX.some(errorCode4xx => errorCode4xx === errorCode)) {
        return <Error4XX />;
      }

      if (errorStatus === 500) {
        return <Error5XX fetch={this.props.fetch} />;
      }

      return null;
    }

    render() {
      const { error } = this.props;

      if (error) {
        return this.renderErrorPage();
      }

      return <Component {...(this.props as any)} />;
    }
  };
}
